export enum eConversationChannelType {
  Phone = 'PHONE',
  Email = 'EMAIL',
  Chat = 'CHAT',
}
